<template>
  <el-col class="header basic-shadow">
    <NavBar :navbar_title="'关于'" />
  </el-col>
  <div class="window-wrapper">
    <main class="custom-container">
      <h1>MCM 资源站</h1>
      <p>© 2023 上海交通大学 数学建模培训营</p>
    </main>
  </div>
</template>

<style>
.header {
  z-index: 2800;
  position: fixed;
  top: 0;
  width: 100%;
  height: 55px;
  padding: 5px 15px;
  width: 100vw;
  border-bottom: 1px solid #cdcdcd;
  background-color: white;
}
.window-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
}
.custom-container {
  display: block;
  margin: 55px;
  height: calc(100% - 55px);
  width: 100vw;
}
h1 {
  display: block;
  font-size: 30px;
  font-weight: bold;
  margin: 1em 0 1em 0;
}
p {
  letter-spacing: 0.2px;
  margin: 0.5em 0 0.5em 0;
}
</style>

<script>
import NavBar from "@/components/NavBar";
export default {
  name: "AboutView",
  props: {},
  data() {
    return {};
  },
  components: { NavBar },
};
</script>
